import { render, staticRenderFns } from "./UserPwd.vue?vue&type=template&id=292d80ea&scoped=true&"
import script from "./UserPwd.vue?vue&type=script&lang=js&"
export * from "./UserPwd.vue?vue&type=script&lang=js&"
import style0 from "./UserPwd.vue?vue&type=style&index=0&id=292d80ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d80ea",
  null
  
)

export default component.exports